React = require 'react'
ReactDriveIn = require 'react-drive-in'

@PLAYLIST = [
  'http://cdn.flyingoctopus.net/bin/video/flyingoctopus.net/Claire_de_Lune.mp4'
,
  'http://cdn.flyingoctopus.net/bin/video/flyingoctopus.net/eots2013.01.web.mp4'
]

@onPlaying = (itemNum) ->
  return

@onPause = ->
  return

VideoBGDriveIn = React.createClass
  getInitialState: ->
    muted: @props.initialChanged

  componentWillReceiveProps: (nextProps) ->
    if nextProps.dataSource != @props.dataSource
      @loadData nextProps.dataSource
    newState = not @state.muted
    @setState muted: newState
    @props.callbackParent newState
    console.log @state.muted
    #video.mute = @state.muted
    #video.mute = if (@state.muted == 'muted') then true else false
    return

  componentDidUpdate: (nextProps) ->
    video = document.getElementsByClassName('drive-in-media')[0].children[0]
    console.log 'didn\'t really update ' + video.muted
    return


  render: ->
    ReactDriveIn = require 'react-drive-in'
    ReactDriveIn.mute = @state.muted

    React.createElement("div", {"className": 'overflow-container'},
      React.createElement(ReactDriveIn, { \
        "id": 'video-background',  \
        "showPlaylist": ['http://cdn.flyingoctopus.net/bin/video/flyingoctopus.net/eots2013.01.web.mp4','http://cdn.flyingoctopus.net/bin/video/flyingoctopus.net/Claire_de_Lune.mp4'],  \
        "onPlaying": (@onPlaying),  \
        "onPause": (@onPause),  \
        "loop": true,  \
        "mute": (@state.muted)
      })
    )
module.exports = VideoBGDriveIn



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./app/components/VideoBG-Drive-In.cjsx
 **/